"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeListener = exports.addListener = void 0;
var Events = [
    "resize",
    "scroll",
    "touchstart",
    "touchmove",
    "touchend",
    "pageshow",
    "load",
];
var managers = [];
function createManager(target) {
    var manager = {
        target: target,
        changeHandlers: {},
        eventHandlers: {},
    };
    Events.forEach(function (type) {
        var listener = function (event) {
            return Object.values(manager.changeHandlers).forEach(function (handler) { return handler && handler(event); });
        };
        target.addEventListener(type, listener);
        manager.eventHandlers[type] = listener;
    });
    return manager;
}
function addListener(target, affixId, onChange) {
    var manager = managers.find(function (manager) { return manager.target === target; }) ||
        createManager(target);
    manager.changeHandlers[affixId] = onChange;
}
exports.addListener = addListener;
function removeListener(target, affixId) {
    var manager = managers.find(function (manager) { return manager.target === target; });
    if (manager) {
        manager.changeHandlers[affixId] = undefined;
        if (Object.values(manager.changeHandlers).filter(function (i) { return !!i; }).length === 0) {
            Events.forEach(function (type) {
                return target.removeEventListener(type, manager.eventHandlers[type]);
            });
            managers = managers.filter(function (manager) { return manager.target !== target; });
        }
    }
}
exports.removeListener = removeListener;
//# sourceMappingURL=AffixManager.js.map